import * as React from "react";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent";
import repository from "client/repository";
import {Text} from "components/form";

interface Props {
    onAdded: () => void | Promise<void>;
}

interface State extends DataBaseComponentState {
    name?: string;
    value?: string;
    description?: string;
}

class AddInstanceEnvironmentVariableDialog extends DataBaseComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    render() {
        return <SaveDialogLayout title={"Add new environment variable"}
                                 busy={this.state.busy}
                                 errors={this.state.errors}
                                 onSaveClick={() => this.save()}>
            <Text label="Variable Name"
                  value={this.state.name}
                  onChange={name => this.setState({name})}
            />
            <Text label="Variable Value"
                  value={this.state.value}
                  onChange={value => this.setState({value})}
            />
            <Text label="Description"
                  value={this.state.description}
                  onChange={description => this.setState({description})}
            />
        </SaveDialogLayout>;
    }

    private async save(): Promise<boolean> {
        return this.doBusyTask(async () => {
            await repository.InstanceEnvironmentVariables.addInstanceEnvironmentVariable(
                this.state.name,
                this.state.value,
                this.state.description
            );
            await this.props.onAdded();
            this.setState({
                name: "",
                value: "",
                description: ""
            });
        });
    }
}

export default AddInstanceEnvironmentVariableDialog;
